import { useEffect, useState, useCallback, useMemo } from 'react';
import debounce from 'transmute/debounce';
import Raven from 'raven-js';
import { useGetVisitorsForDocumentQuery, useGetVisitorsForDocumentAndSearchQueryQuery } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsAnalyticsService.hooks';
import { VISITORS_PAGE_LIMIT } from '../api/DocumentsApi';
import { isUngatedToCHIRPEndpoints } from '../utils/gates';
export const useGetDocumentVisitors = ({
  documentId,
  limit = VISITORS_PAGE_LIMIT,
  offset = 0,
  searchQuery = ''
}) => {
  const hasSearchQuery = (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.trim()) !== '';
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  const handleVisitorsError = useCallback(error => {
    Raven.captureException(error, {
      extra: {
        documentId,
        limit,
        offset
      }
    });
  }, [documentId, limit, offset]);
  const handleVisitorsSearchQueryError = useCallback(error => {
    Raven.captureException(error, {
      extra: {
        documentId,
        searchQuery,
        limit,
        offset
      }
    });
  }, [documentId, searchQuery, limit, offset]);
  const {
    data: baseVisitorsData,
    loading: baseVisitorsLoading,
    error: baseVisitorsError
  } = useGetVisitorsForDocumentQuery({
    variables: {
      documentId,
      limit,
      offset
    },
    skip: !isUngatedToChirp || hasSearchQuery,
    onError: handleVisitorsError
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSetSearchQuery = useCallback(debounce(300, query => setDebouncedSearchQuery(query)), []);
  useEffect(() => {
    debouncedSetSearchQuery(searchQuery);
  }, [debouncedSetSearchQuery, searchQuery]);
  const {
    data: visitorsSearchQueryData,
    loading: visitorsSearchQueryLoading,
    error: visitorsSearchQueryError
  } = useGetVisitorsForDocumentAndSearchQueryQuery({
    variables: {
      documentId,
      searchQuery: debouncedSearchQuery,
      limit,
      offset
    },
    skip: !isUngatedToChirp || !hasSearchQuery,
    onError: handleVisitorsSearchQueryError
  });
  const visitorsData = useMemo(() => {
    return {
      data: hasSearchQuery ? visitorsSearchQueryData : baseVisitorsData,
      loading: hasSearchQuery ? visitorsSearchQueryLoading : baseVisitorsLoading,
      error: hasSearchQuery ? visitorsSearchQueryError : baseVisitorsError
    };
  }, [hasSearchQuery, visitorsSearchQueryData, baseVisitorsData, visitorsSearchQueryLoading, baseVisitorsLoading, visitorsSearchQueryError, baseVisitorsError]);
  return visitorsData;
};